import { render, staticRenderFns } from "./regionalManagement.vue?vue&type=template&id=c087ec1a&scoped=true"
import script from "./regionalManagement.vue?vue&type=script&lang=js"
export * from "./regionalManagement.vue?vue&type=script&lang=js"
import style0 from "./regionalManagement.vue?vue&type=style&index=0&id=c087ec1a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c087ec1a",
  null
  
)

export default component.exports